import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { retry, catchError, delay, tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class StudentOverAllHistoryService {
  readonly baseURL = sessionStorage.getItem('NbaseURLs');
  constructor(private http: HttpClient) { }

  //ViewStudLedgerDet(Admno: string, YearCode: Number): Observable<any> {
  ViewStudLedgerDetIndividual2023(YearCode: number, Admno: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudLedgerDetIndividual2023?YearCode=' + YearCode + '&&Admno=' + Admno)
      .pipe(delay(0), catchError(this.handleError));
      //.pipe(
      //  map(response => response || null),
      //  catchError((error: HttpErrorResponse) => {
      //    console.error('Error fetching value:', error);
      //    return of(null);
      //  })
    //console.log("result");
      //.pipe(tap(res => {
      //  if (res.ok) {
      //    // you are authenticated
      //  }
      //}))
      //.pipe(delay(1000), catchError(this.handleError))
  }

  DeleteStudentFeeTranAll(MaxRNo: string, Yearcode: number) {
    return this.http.delete(this.baseURL + '/DeleteStudentFeeTranAll?Admno=' + MaxRNo + '&&Yearcode=' + Yearcode);
  }

  ViewStudLedgerDetSumIndividual(YearCode: number, Admno: string): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAllSumIndividual?YearCode=' + YearCode + '&&Admno=' + Admno)
      .pipe(retry(1), catchError(this.handleError));
  }

  GetCourses(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/GetCourses?YearCode=' + parseInt(sessionStorage.getItem('YearCode')))
      .pipe(retry(1), catchError(this.handleError));
  }

  ViewStudFeeDetailsDet(Admno: string, YearCode: Number): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDet?Admno=' + Admno + '&&YearCode=' + YearCode);
  }
  ViewStudFeeDetailsDetAll(): Observable<any> {
    debugger;
    return this.http.get<any>(this.baseURL + '/ViewStudFeeDetailsDetAll')
      .pipe(retry(1), catchError(this.handleError));
  }
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
